<script setup>
import {
    AdjustmentsHorizontalIcon,
    ArrowDownIcon,
    ArrowRightIcon,
    DocumentArrowUpIcon,
    PresentationChartLineIcon,
} from '@heroicons/vue/24/outline'

import BrandButton from '@/components/ui/BrandButton.vue'
import SectionHeading from '@/components/ui/SectionHeading.vue'

const steps = [
    {
        number: '01',
        title: 'Nastavení spolupráce',
        description: 'Probereme vaše potřeby a společně vybereme balíček služeb, který vám nejlépe sedne.',
        icon: AdjustmentsHorizontalIcon,
    },
    {
        number: '02',
        title: 'Předání dokladů',
        description:
            'Domluvíme se na předání dokladů - online přes aplikaci, nebo postaru v papírové podobě. Volba je na vás.',
        icon: DocumentArrowUpIcon,
    },
    {
        number: '03',
        title: 'Zpracování a report',
        description:
            'Vaše data pečlivě zpracujeme a vy máte díky online přístupu přehled o tom, jak na tom vaše finance jsou.',
        icon: PresentationChartLineIcon,
    },
]
</script>

<template>
    <section
        class="bg-white py-20 md:py-28"
        id="process"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <SectionHeading title="Jak spolupracujeme" />

            <ol class="mt-16 grid gap-10 lg:grid-cols-3 lg:gap-16">
                <li
                    class="relative"
                    v-for="(step, index) in steps"
                    :key="step.number"
                >
                    <div
                        class="flex h-full flex-col rounded-2xl border border-zinc-200 bg-white p-8 shadow-sm shadow-zinc-200/40"
                    >
                        <div class="flex items-center justify-between">
                            <span
                                class="bg-brand-900 flex size-12 items-center justify-center rounded-xl text-white"
                                aria-hidden="true"
                            >
                                <component
                                    class="size-6"
                                    :is="step.icon"
                                    stroke-width="1.5"
                                />
                            </span>

                            <span
                                class="text-accent-500/90 text-5xl font-extrabold tracking-tighter tabular-nums md:text-6xl"
                                aria-hidden="true"
                            >
                                {{ step.number }}
                            </span>
                        </div>

                        <h3 class="text-brand-900 mt-6 text-xl font-bold tracking-tight md:text-2xl">
                            <span class="sr-only">Krok {{ index + 1 }}: </span>{{ step.title }}
                        </h3>

                        <p class="mt-3 text-base leading-relaxed text-zinc-600">
                            {{ step.description }}
                        </p>
                    </div>

                    <div
                        class="flex justify-center py-3 lg:absolute lg:top-1/2 lg:-right-8 lg:translate-x-1/2 lg:-translate-y-1/2 lg:py-0"
                        v-if="index < steps.length - 1"
                        aria-hidden="true"
                    >
                        <span
                            class="bg-accent-50 text-accent-600 ring-accent-100 flex size-9 items-center justify-center rounded-full shadow-sm ring-1"
                        >
                            <ArrowDownIcon class="size-5 lg:hidden" />
                            <ArrowRightIcon class="hidden size-5 lg:block" />
                        </span>
                    </div>
                </li>
            </ol>

            <div class="mt-12">
                <BrandButton
                    class="group"
                    variant="ghost"
                    href="#sluzby"
                >
                    Prohlédnout služby
                    <ArrowRightIcon
                        class="ml-1.5 size-4 transition-transform group-hover:translate-x-1"
                        aria-hidden="true"
                    />
                </BrandButton>
            </div>
        </div>
    </section>
</template>
